module.exports = __webpack_public_path__ + "media/images/new-07f18ee0ba5fc2546dd20d2f894d6f72.svg";